export { default } from './CallSkeleton';
